module.exports = __webpack_public_path__ + "img/mediaIcon1.452d87c2.png";